import { ColumnsType, defaultTheme } from '@agro-club/agroclub-shared'
import { TFunction } from 'i18next'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { EditRoadRatesCell } from './components/EditRoadRatesCell'
import { RangeType, RateType } from './types'
import { RateCell } from './components/RateCell'

const getColumns = (range: RangeType[], t: TFunction, onSuccess: () => void) => {
  const rangeColumns = range.map((range) => ({
    key: range.upper.toString(),
    title: range.upper,
    width: 56,
    align: 'right',
    dataIndex: 'logistics_rates',
    render: (logistics_rates: RateType[]) => <RateCell logistics_rates={logistics_rates} range={range} />,
    onCell: (record) => {
      const rates: RateType[] = record.logistics_rates
      const rate = rates.find(
        (rate) => rate.distance_range.lower === range.lower && rate.distance_range.upper === range.upper,
      )
      let cellColor: string | undefined
      if (rate?.history_info) {
        if ((rate.rate || 0) > (rate.history_info.rate || 0)) {
          cellColor = defaultTheme.color.accentDestruct16a
        } else if ((rate.rate || 0) < (rate.history_info.rate || 0)) {
          cellColor = defaultTheme.color.accentApprove16a
        }
      }
      return { style: { backgroundColor: cellColor } }
    },
  }))

  const results = [
    ...rangeColumns,
    {
      title: '',
      width: 50,
      dataIndex: 'id',
      align: 'center',
      fixed: 'right',
      render: (id, data) => <EditRoadRatesCell onSuccess={onSuccess} ratesData={data.logistics_rates} />,
    },
  ] as ColumnsType<any>

  return results
}

export const useAverageColumns = (range: RangeType[], onSuccess: () => void): ColumnsType<any> => {
  const { t } = useTranslation('rates')

  return useMemo(() => getColumns(range, t, onSuccess), [range, t, onSuccess])
}
